import { NgModule } from '@angular/core';
import { IdentityModule, UsersComponent } from '@volo/abp.ng.identity';
import { ExtendedUsersComponent } from './extended-users.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { PageModule } from '@abp/ng.components/page';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TreeModule } from '@abp/ng.components/tree';
import { PermissionManagementModule } from '@abp/ng.permission-management'
import { NgxValidateCoreModule } from '@ngx-validate/core'
import { UiExtensionsModule } from '@abp/ng.theme.shared/extensions';

@NgModule({
    declarations: [ExtendedUsersComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule,
        ThemeSharedModule,
        CommercialUiModule,
        PageModule,
        IdentityModule,
        NgbModule,
        TreeModule,
        PermissionManagementModule,
        NgxValidateCoreModule,
        UiExtensionsModule,
    ],
    exports: [ExtendedUsersComponent],
    providers:[UsersComponent]
})
export class ExtendedUsersModule {}